import { createFileRoute } from '@tanstack/react-router';
import { HowYouUseHayvenPage } from './business-setup/how-you-use-hayven-page';

export const Route = createFileRoute('/_auth/$orgId/settings/business-setup/how-you-use-hayven')({
  component: HowYouUseHayvenPage,
});
